import { UserRoleEnum } from 'app/services/user';
import { AccessRule } from './rules';
/**
 *   ✔︎  'ALL'                        → everyone (Admin, Accountant, Client)
 *   ✔︎  UserRoleEnum[]              → any of those roles
 *   ✔︎  { dept: number[] }          → accountants/admins that belong to *any* of the depts
 *   ✔︎  { role, dept }              → role intersection + dept union
 */
export const ACCESS: Record<string, AccessRule> = {
  dashboard: 'ALL',
  tasks: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [1, 2, 3, 4, 7],
  },
  timesheets: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [1, 2, 3, 4, 7],
  },
  taxReturns: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [3, 4, 5, 7],
  }, // Tax FO/BO
  taxEstimates: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [3, 4, 5, 7],
  },
  taxExtensions: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [3, 4, 5, 7],
  },
  taxFinCEN: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [3, 4, 5, 7],
  }, // full for Finance BO

  documents: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [1, 2, 3, 4, 7],
  },
  services: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [1, 3, 5, 7],
  },
  controlServices: { role: [UserRoleEnum.ADMIN], dept: [7] },

  aiMito: 'ALL',
  messages: 'ALL',
  privacy: 'ALL',

  promoCodes: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [5, 7],
  }, // Finance, Support, IT
  announcements: { role: [UserRoleEnum.ADMIN], dept: [7] },
  upcomingDates: { role: [UserRoleEnum.ADMIN], dept: [7] },
  tickets: { dept: [6, 7] }, // Support only
  bundles: { role: [UserRoleEnum.ACCOUNTANT], dept: [1, 3] },

  clients: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [1, 2, 3, 4, 7],
  }, // HR can’t see clients
  accountants: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [7, 8],
  }, // HR & IT

  journalEntries: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [1, 2, 7],
  }, // Accounting FO/BO & IT

  accounts: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [1, 2, 7],
  },
  /* Headers inherit visibility from children */
  tax: {
    role: [UserRoleEnum.ADMIN, UserRoleEnum.ACCOUNTANT],
    dept: [3, 4, 5, 7],
  }, // Only visible when at least one child will render
} as const;
